import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_analitica`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_analitica/get/list`);
  return response;
};

const getAllComplete = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_analitica/get/all`);
  return response;
};

const getAllActive = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_analitica/get/active`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_analitica/${id}`);
  return response;
};

const getByOdooId = async (odooId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_analitica/odoo/${odooId}`);
  return response;
};


export {getAll, getList,getAllComplete,getAllActive,getById,getByOdooId};